import React from 'react';
import './Card.sass';

interface CardProps {
  height?: '100' | '';
  width?: '12' | '11' | '10' | '9' | '8' | '7' | '6' | '5' | '4' | '3' | '2' | '1' | '';
  children: React.ReactNode;
}

function Card(props: CardProps) {
  return (
    <figure
      className="card"
      data-height={props.height}
      data-width={props.width}
    >
      {props.children}
    </figure>
  );
}

export default Card;
